/**
 * Códigos de tax system (`tax_system_config.code`) que el front usa por nombre: elegir la pantalla de una empresa en
 * los selectores por tax system (oferta, revisión del expediente, firma) o pedir su configuración en un cotizador.
 */
export const TAX_SYSTEMS_CODES = {
  // CREDIMOTO TAX SYSTEMS CODES
  CREDIMOTO_PF: "CSCM2",

  // MERCADER TAX SYSTEMS CODES
  // Mercader: cada vía de la decisión de ingresos tiene su tax system (con CIEC / sin CIEC).
  MERCADER_PFAE: "MER01",
  MERCADER_PM: "MER02",
  MERCADER_PFAE_SIN_CIEC: "MER03",
  MERCADER_PM_SIN_CIEC: "MER04",

  // FLUX TAX SYSTEMS CODES
  FLUX_PM: "FLXPM",
  FLUX_PFAE: "FLXPF",
  WUWEI_PF: "CAWWE",

  PROVIDENCIA_CREDITO_SIMPLE_PM: "CFP01",
  PROVIDENCIA_CREDITO_SIMPLE_PFAE: "CFP02",
  PROVIDENCIA_CUENTA_CORRIENTE_PM: "CFP03",
  PROVIDENCIA_CUENTA_CORRIENTE_PFAE: "CFP04",
  PROVIDENCIA_AVIO_PM: "CFP05",
  PROVIDENCIA_AVIO_PFAE: "CFP06",
  PROVIDENCIA_REFACCIONARIO_PM: "CFP07",
  PROVIDENCIA_REFACCIONARIO_PFAE: "CFP08",

  KAPITAL_PARTNERS_CS_PM: "KPR01",
  KAPITAL_PARTNERS_CS_PFAE: "KPR02",
  KAPITAL_PARTNERS_FX_USD_PM: "KPR03",
  KAPITAL_PARTNERS_FX_USD_PFAE: "KPR04",
  KAPITAL_PARTNERS_CC_PM: "KPR05",
  KAPITAL_PARTNERS_CC_PFAE: "KPR06",
};
